import {
  AGENDA_QUICK_ACTIONS,
  actionCompleted,
  isAgentSupportInProgress,
  isAgentSupportPending,
} from './agendaQuickActions';

export const AGENDA_SEND_ACTIONS = Object.freeze({
  SEND_OFFER_LINK: 'sendOfferLink',
  SEND_INTRODUCTION: 'sendIntroduction',
  START_SUPPORT: 'startSupport',
  CONFIRM_VISIT: 'confirmVisit',
  START_VISIT: 'startVisit',
  START_TALK_TO_OWNER: 'startTalkToOwner',
  ADD_MORE_VISITS: 'addMoreVisits',
  VISIT_FOLLOW_UP: 'visitFollowUp',
});

export const AGENDA_SEND_ACTION_TEXT = Object.freeze({
  SEND_OFFER_LINK: 'Enviar link de proposta',
  SEND_INTRODUCTION: 'Enviar apresentação',
  START_SUPPORT: 'Iniciar atendimento',
  CONFIRM_VISIT: 'Confirmar visita',
  START_VISIT: 'Iniciar visita',
  START_TALK_TO_OWNER: 'Conversar com proprietário',
  ADD_MORE_VISITS: 'Adicionar mais visitas',
  VISIT_FOLLOW_UP: 'Finalizar Visita',
});

const text = value => String(value || '').trim();

const labelWithPrefix = ({ prefix, suffix, fallback, finalTerms = [] }) => {
  const value = text(prefix);
  if (!value) return fallback;

  const normalized = value.toLocaleLowerCase('pt-BR');
  if (
    [suffix, ...finalTerms].some(term =>
      normalized.includes(term.toLocaleLowerCase('pt-BR'))
    )
  ) {
    return value;
  }

  return `${value} ${suffix}`;
};

const completedPrefix = ({ visit, action, fallback }) =>
  actionCompleted(visit, action) ? 'Reenviar' : fallback;

export const buildAgendaSendActions = ({
  visit = {},
  canSendIntroduction = false,
  canSendOffer = false,
  introductionLabel = '',
  offerLabel = '',
} = {}) => {
  const actions = [];

  if (isAgentSupportPending(visit)) {
    actions.push({
      key: AGENDA_SEND_ACTIONS.START_SUPPORT,
      label: AGENDA_SEND_ACTION_TEXT.START_SUPPORT,
      icon: 'i-lucide-headphones',
      event: 'startSupport',
      referenceAction: 'StartSupportAction',
    });
  } else {
    actions.push({
      key: AGENDA_SEND_ACTIONS.SEND_INTRODUCTION,
      label: isAgentSupportInProgress(visit)
        ? AGENDA_SEND_ACTION_TEXT.CONFIRM_VISIT
        : labelWithPrefix({
            prefix:
              introductionLabel ||
              completedPrefix({
                visit,
                action: AGENDA_QUICK_ACTIONS.INTRODUCTION,
                fallback: 'Enviar',
              }),
            suffix: 'apresentação',
            fallback: AGENDA_SEND_ACTION_TEXT.SEND_INTRODUCTION,
          }),
      icon: isAgentSupportInProgress(visit)
        ? 'i-lucide-circle-check'
        : 'i-lucide-message-circle',
      event: 'sendIntroduction',
      disabled: !canSendIntroduction,
      referenceAction: 'SendIntroductionAction',
    });
  }

  actions.push(
    {
      key: AGENDA_SEND_ACTIONS.SEND_OFFER_LINK,
      label: labelWithPrefix({
        prefix:
          offerLabel ||
          completedPrefix({
            visit,
            action: AGENDA_QUICK_ACTIONS.OFFER,
            fallback: 'Enviar',
          }),
        suffix: 'link de proposta',
        fallback: AGENDA_SEND_ACTION_TEXT.SEND_OFFER_LINK,
        finalTerms: ['proposta'],
      }),
      icon: 'i-lucide-file-signature',
      event: 'sendOffer',
      disabled: !canSendOffer,
      referenceAction: 'SendOfferAction',
    },
    {
      key: AGENDA_SEND_ACTIONS.START_TALK_TO_OWNER,
      label: AGENDA_SEND_ACTION_TEXT.START_TALK_TO_OWNER,
      icon: 'i-lucide-user-round-cog',
      event: 'talkOwner',
      referenceAction: 'StartTalkToOwnerAction',
    },
    {
      key: AGENDA_SEND_ACTIONS.ADD_MORE_VISITS,
      label: AGENDA_SEND_ACTION_TEXT.ADD_MORE_VISITS,
      icon: 'i-lucide-calendar-plus',
      event: 'addMore',
      referenceAction: 'AddMoreVisitsAction',
    },
    {
      key: AGENDA_SEND_ACTIONS.VISIT_FOLLOW_UP,
      label: AGENDA_SEND_ACTION_TEXT.VISIT_FOLLOW_UP,
      icon: 'i-lucide-flag',
      event: 'followUp',
      referenceAction: 'VisitFollowUpAction',
    }
  );

  return actions;
};
